var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Arrow Up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Locations-Feature",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow-alt/Up"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20080645,13.6666667 L6.79919355,13.6666667 C6.4664701,13.6666667 6.19879032,13.3960123 6.19879032,13.0595916 L6.19879032,8.00063237 L3.60204638,8.00063237 C3.06668683,8.00063237 2.79900706,7.34802663 3.17676076,6.96354574 L7.57471438,2.51166164 C7.80987231,2.27389056 8.19012769,2.27389056 8.42528562,2.51166164 L12.8232392,6.96354574 C13.2009929,7.34549715 12.9333132,8.00063237 12.3979536,8.00063237 L9.80120968,8.00063237 L9.80120968,13.0595916 C9.80120968,13.3960123 9.5335299,13.6666667 9.20080645,13.6666667 Z",
    id: "Icon",
    fill: "#656768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon-up.3447d6f2.svg";
export { ForwardRef as ReactComponent };